import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=1687a270&scoped=true"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=1687a270&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1687a270",
  null
  
)

export default component.exports